import { createContext } from "react";

export interface IWallet {
  id: number
  showStake: boolean
  showUnStake?: boolean
  status?: boolean
}

export const WalletContext =  createContext<IWallet | undefined>(undefined);